const DEFAULTS = {
    absoluteFloor: 0.02,
    relativeFloor: 0.6,
    transientWeight: 2.0,
    energyWeight: 2.5,
    voicingPenalty: 0.8,
    keepFraction: 0.25,
    minKeep: 2,
};
export function pickBurstFrames(frames, opts = {}) {
    const o = { ...DEFAULTS, ...opts };
    if (frames.length <= 3)
        return frames;
    let peak = 0;
    for (const f of frames)
        if (f.energy > peak)
            peak = f.energy;
    const floor = Math.max(o.absoluteFloor, peak * o.relativeFloor);
    const energetic = frames.filter((f) => f.energy > floor);
    const pool = energetic.length >= 3 ? energetic : frames;
    const score = (f) => f.transient * o.transientWeight +
        f.energy * o.energyWeight -
        f.voicing * o.voicingPenalty;
    const ranked = [...pool].sort((a, b) => score(b) - score(a));
    const keepN = Math.max(Math.min(o.minKeep, ranked.length), Math.round(ranked.length * o.keepFraction));
    return ranked.slice(0, keepN);
}
